import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { ProjectView } from "@app/shared/provider-change-wizards/interfaces";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";
import { QESRadioGroup } from "@app/shared/qes-standards/forms/RadioGroup";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { checkForEnter } from "@app/shared/utility/checkForEnter";
import { Dispatch, FC, RefObject, SetStateAction, useMemo } from "react";

interface ProjectOrTagSearchProps {
  filteredView: ProjectView;
  inputRef: RefObject<HTMLInputElement>;
  searchString: string;
  setView: Dispatch<SetStateAction<ProjectView>>;
  updateSearchString: (value: string) => void;
  view: ProjectView;
}

export const ProjectOrTagSearchBox: FC<ProjectOrTagSearchProps> = (props: ProjectOrTagSearchProps) => {
  const closeX = useMemo(() => (
    <span
      className="d-inline-flex align-items-center qes-text-input__clear-button"
      onClick={() => {
        props.updateSearchString("");
        props.inputRef.current.value = "";
        props.inputRef.current.focus();
      }}
    >
      <QesIcon iconName={QesIcons.XClose} description="clear search field and reset results" />
    </span>
  ), []);

  return (
    <div>
      <fieldset className="">
        <span className="label-s">Search By</span>
        <div className="col-12 d-flex ps-0">
          <QESRadioGroup
            renderInline={true}
            groupContainerClass="col-3 ps-0 d-flex align-items-center"
          >
            <QESRadioButton
              value="projects"
              label="Projects"
              testId="select-projects__projects-radio"
              name="view"
              checked={props.view === "projects"}
              onChange={() => props.setView("projects")}
            />
            <QESRadioButton
              value="tags"
              label="Tags"
              testId="select-projects__tags-radio"
              name="view"
              checked={props.view === "tags"}
              onChange={() => props.setView("tags")}
            />
          </QESRadioGroup>
          <QESTextInput
            id="filter-projects"
            testId="select-projects__search-input"
            defaultValue=""
            qesRef={props.inputRef}
            label="Search By"
            hideLabel={true}
            onKeyUp={(e) => checkForEnter(e, () => props.updateSearchString(props.inputRef.current.value))}
            containerClassName="col-8 px-2"
            inputAppend={closeX}
            className="bg-white"
          />
          <div className="col-1 d-inline-flex justify-content-center align-items-center">
            <QESButton
              qesType="secondary"
              onClick={() => props.updateSearchString(props.inputRef.current.value)}
              qesTestId="select-projects__search-button"
            >
              Search
            </QESButton>
          </div>
        </div>
      </fieldset>
      {!!props.filteredView && <span className="mb-2">Currently filtered to {props.filteredView} including &quot;{props.searchString}.&quot;</span>}
    </div>
  )
}